export default __webpack_public_path__ + "static/media/Robot.30500438.webm";